<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, Divider } from '#library/components.schema.build.ts'

	interface Props {
		blok: Blok<Divider>
	}

	let { blok }: Props = $props()
</script>

<div class="divider {blok.theme || 'theme-lupton-on-light-gimson'}" {...attrs(blok)}>
	<hr class="line contain" />
</div>

<style lang="css">
	.divider {
		background-color: var(--c-background);
		padding-block: var(--padding-top, 0) var(--padding-bottom, 0);
	}

	.line {
		background-color: var(--c-foreground);
		opacity: 0.5;
	}
</style>
